import SwiperCore, { A11y, Mousewheel, Navigation, Pagination } from "swiper";
import { SwiperSlide } from "swiper/react";
import { StyledSwiper } from "./FiltersCarousel.styles";
import { FiltersCarouselProps } from "./FiltersCarousel.types";
/* eslint-disable import/no-unresolved */
import "swiper/css";
import "swiper/css/a11y";
import "swiper/css/pagination";
import "swiper/css/navigation";
/* eslint-enable import/no-unresolved */

SwiperCore.use([A11y, Mousewheel, Pagination, Navigation]);

export function FiltersCarousel({
  children,
  hasPagination=false,
  label,
  ...props
}: FiltersCarouselProps) {


  const cards =
    (!Array.isArray(children) && children != undefined) // not null or undefined
      ? [children]
      : children;

  if(!cards || cards.filter((card) => card).length === 0) return null;

  return (
    <StyledSwiper
      key={ label }
      a11y={ { enabled: true, slideRole: "group", slideLabelMessage: "" } }
      // centeredSlides={ true }
      direction={ "horizontal" }
      mousewheel={ true }
      navigation={ true }
      pagination={
        hasPagination ? {
          clickable: true
          // dynamicBullets: true
        } : false
      }
      slidesPerView={ "auto"  }
      spaceBetween={ 0 }
      { ...props }
    >
      {
        cards?.filter((card) => card).map((card, idx) => (
          <SwiperSlide  style={ {
            padding: "8px",       
            boxSizing: "border-box"
          } } tabIndex={ -1 } key={ `carousel-${label}--card-${idx}` }>
            { card }
          </SwiperSlide>
        ))
      }
    </StyledSwiper>
  );
}
